import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Suche = _resolveComponent("Suche")!
  const _component_loading_container = _resolveComponent("loading-container")!

  return (_openBlock(), _createBlock(_component_loading_container, {
    state: _ctx.state,
    i18nErrorMessage: _ctx.getI18nErrorString(),
    "error-uuid": _ctx.errorUuid
  }, {
    default: _withCtx(() => [
      (_ctx.lookUpValuesTopic)
        ? (_openBlock(), _createBlock(_component_Suche, {
            key: 0,
            topics: _ctx.lookUpValuesTopic,
            regions: _ctx.regions,
            messages: _ctx.searchMessages,
            type: _ctx.type,
            selectedTopicsProp: _ctx.selectedTopics,
            selectedRegionProp: _ctx.selectedRegion,
            selectedLong: _ctx.selectedLong,
            selectedLat: _ctx.selectedLat,
            onSubmit: _ctx.getEmit
          }, null, 8, ["topics", "regions", "messages", "type", "selectedTopicsProp", "selectedRegionProp", "selectedLong", "selectedLat", "onSubmit"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["state", "i18nErrorMessage", "error-uuid"]))
}